export const modelPermissionsGroupPermissionsConst = {
  view: {
    value: "view_group",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu grup!",
  },
  add: {
    value: "add_group",
    errorMsg: "Użytkownik nie ma uprawnień do dodania grup!",
  },
  update: {
    value: "change_group",
    errorMsg: "Użytkownik nie ma uprawnień do edycji grup!",
  },
  delete: {
    value: "delete_group",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania grup!",
  },
};
